<template>
  <div class="live-banner-item">
    <img
      :src="require('@/assets/images/live/logo/lvzhou.png')"
      class="logo"
      alt=""
    />
    <div class="space"></div>
    <img
      alt=""
      :src="require('@/assets/images/live/logo/baiji.png')"
      class="baiji-logo"
    />
    <div class="title">
      <span class="title_text">{{ meetingInfo.meet_name || "测试会议" }}</span>
    </div>
  </div>
</template>
<script>
export default {
  name: "live-banner",
  props:{
    meetingInfo:{
      type:Object,
      default:()=>{
        return {}
      }
    }
  }
};
</script>
<style scoped>
.live-banner-item {
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  padding: 0.0667rem;
  background: #fff;
}
.logo {
  width: 1.631667rem;
  height: auto;
  padding: 0 0.35rem;
}
.baiji-logo {
  width: 2.575667rem;
  height: auto;
  padding: 0 0.33rem;
}
.space {
  height: 0.66667rem;
  width: 1px;
  background: rgb(172, 172, 171);
}
.title {
  height: 1.386333rem;
  display: flex;
  align-items: center;
  overflow: hidden;
}
.title_text{
  min-height: 0.666667rem;
  max-height: 1.386667rem;
  font-weight: 600;
  font-size: 0.48rem;
  line-height: 0.666667rem;
  overflow: hidden;
  word-break: break-all;
  text-overflow: ellipsis;
  -webkit-text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;

}
</style>